import { createSlice } from '@reduxjs/toolkit';
import { LOCALE_STORAGE_KEY } from 'client/utils/constants/browserStorageKeys';
import { LOCALES } from 'i18n/locales';

const getInitialLocale = () => {
    try {
        const stored = sessionStorage.getItem(LOCALE_STORAGE_KEY);
        if (stored === LOCALES.WELSH || stored === LOCALES.ENGLISH) {
            return stored;
        }
    } catch (e) {
        // Ignore sessionStorage errors
    }
    return LOCALES.ENGLISH;
};

const setLocaleInStorage = (locale) => {
    try {
        sessionStorage.setItem(LOCALE_STORAGE_KEY, locale);
    } catch (e) {
        // Ignore sessionStorage errors
    }
};

export const localeSlice = createSlice({
    name: 'locale',
    initialState: {
        current: getInitialLocale()
    },
    reducers: {
        setLocale: (state, action) => {
            const locale = action?.payload;
            const newLocale = locale === LOCALES.WELSH ? locale : LOCALES.ENGLISH;
            setLocaleInStorage(newLocale);
            return { ...state, current: newLocale };
        }
    }
});

export const { setLocale } = localeSlice.actions;

export default localeSlice.reducer;
